import React, { useState } from 'react';
import { cdnDomain } from '../utilities/config';
import { IoShieldCheckmarkSharp } from '@react-icons/all-files/io5/IoShieldCheckmarkSharp'
import { Helpers } from '../utilities/helpers';
import Button from './Button';

const InsuredVehicleItem = (props) => {
    const { vehicle, onEdit } = props
    const [showRegTooltip, setShowRegTooltip] = useState(false)
    const [showMakeTooltip, setShowMakeTooltip] = useState(false)

    return (
        <div className="insured-vehicle-list-wrapper" key={vehicle.id}>
            <div className="insured-vehicle-list-item">
                <img
                    className="insured-vehicle-list-item-img"
                    src={vehicle && vehicle.creativeImage ? vehicle.creativeImage : `${cdnDomain}/static/images/shadowVehicle.png`}
                    alt="Vehicle"
                />
                <div className="tool-tip-registration-container">
                    <h1 className="vehicle-list-item-item-registration" onMouseEnter={() => setShowRegTooltip(true)} onMouseLeave={() => setShowRegTooltip(false)}>
                        {vehicle && vehicle.registration ? Helpers.displayReg(vehicle.registration) : 'TBA'}
                    </h1>
                    {showRegTooltip && vehicle && vehicle.registration.length > 10 && (
                        <span className="tool-tip-registration">{vehicle.registration}</span>
                    )}
                </div>
            </div>
            <div className="insured-vehicle-list-item">
                <div className="tool-tip-make-container">
                    <h1 className="insured-vehicle-list-item-value-text" onMouseEnter={() => setShowMakeTooltip(true)} onMouseLeave={() => setShowMakeTooltip(false)}>
                        {vehicle && vehicle.make ? Helpers.displayMake(vehicle.make) : 'TBA'}
                    </h1>
                    {showMakeTooltip && vehicle && vehicle.make.length > 13 && (
                        <span className="tool-tip-make">{vehicle.make}</span>
                    )}
                </div>
                <h1 className="insured-vehicle-list-item-value-heading">{vehicle.model.split(' ')[0]}</h1>
                <Button
                    title={'Edit'}
                    onClick={onEdit}
                />
            </div>
            <div className="insured-vehicle-list-item">
                <div className="insured-vehicle-list-item-shield">
                    <IoShieldCheckmarkSharp className="insured-vehicle-shield-icon"/>
                    <p className="insured-vehicle-shield-icon-label-text" >INSURED</p>
                </div>
            </div>
        </div>
    )
}

export default InsuredVehicleItem
